<template>
  <div class="home">
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarContent }}
      <v-btn text @click="snackbar = false" timeout="3000">{{$t('close')}}</v-btn>
    </v-snackbar>

    <v-container class="mt-12">
      <v-card class="mx-auto" width="95%">
        <v-card-title>
          {{$t('courses')}}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-account-search-outline"
            label="Rechercher"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="allCourses"
          class="elevation-1"
          :loading="getDataLoader"
          loading-text="Chargement, veuillez patienter"
        >
          <template v-slot:item.trainingCenterLocation="{ item }">
            {{ item.trainingCenterLocation.city.cityName }}, {{item.trainingCenterLocation.address}}
            <br />
            <span style="font-style: italic">{{item.trainingCenterLocation.city.pinCode}}</span>
          </template>

          <template v-slot:item.startingDate="{ item }">{{ formatDateTime(item.startingDate) }}</template>

          <template v-slot:item.endingDate="{ item }">{{ formatDateTime(item.endingDate) }}</template>

          <template v-slot:item.confirmed="{ item }">
            <v-chip class="ma-2" color="success" text-color="white" v-if="item.confirmed">
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-chip>

            <v-chip class="ma-2" color="red" text-color="white" v-else>
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-chip>
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="elevation-1"
                  color="yellow darken-2 white--text"
                  fab
                  small
                  @click="openconfirmInternshipDialog(item.id)"
                  :disabled="item.confirmed != null"
                >
                  <v-icon right class="mr-2" v-on="on">mdi-clipboard-check-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Confirmation</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="confirmInternshipDialog" width="50%">
      <v-card>
        <v-card-title
          class="headline primary white--text pa-2"
          primary-title
        >Confirmer ou refuser le stage?</v-card-title>
        <v-card-text class="pt-12 text-center">
          <v-btn x-large color="success mx-3 my-12" @click="confirmationSave(true)">Confirmer</v-btn>
          <v-btn
            x-large
            color="red lighten-1 mx-3 my-12"
            dark
            @click="confirmationSave(false)"
          >Rejeter</v-btn>
        </v-card-text>
        <v-card-actions class="pt-12 pb-4 mx-2">
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="confirmInternshipDialog = false">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

export default {
  data() {
    return {
      search: "",

      snackbar: false,
      snackbarContent: null,
      snackbarColor: null,

      allCourses: [],
      getDataLoader: false,
      headers: null,
      confirmInternshipDialog: false,

      confirmInternshipTitle: null,
      internshipId: null
    };
  },
  created() {
    // -------------------------- Get all courses ------------------------------
    this.getDataLoader = true;
    this.$http
      .get("/trainer/" + this.user.id + "/findAll/internship", {
        headers: { Authorization: "Bearer " + this.$store.state.token }
      })
      .then(res => {
        this.allCourses = [];

        res.data.forEach(course => {
          course.confirmed = null;

          if (
            this.user.id == course.bafm.id &&
            course.bafmConfirmedOn != null
          ) {
            course.confirmed = course.hasBafmConfirmation;
          } else if (
            this.user.id == course.psychologist.id &&
            course.psycologistConfirmedOn != null
          ) {
            course.confirmed = course.hasPsycologistConfirmation;
          }

          this.allCourses.push(course);
        });

        this.getDataLoader = false;

        console.log(this.allCourses);
      })
      .catch(e => {
        console.log(e.response);
        this.getDataLoader = false;
      });
    // -------------------------------------------------------------------------

    this.i18n =
      this.$i18n.locale == "fr"
        ? this.$i18n.messages.fr
        : this.$i18n.messages.en;

    this.headers = [
      {
        text: this.i18n.location,
        value: "trainingCenterLocation",
        width: "20%"
      },
      { text: this.i18n.startDate, value: "startingDate", width: "20%" },
      { text: this.i18n.endDate, value: "endingDate", width: "20%" },
      {
        text: "confirmé",
        value: "confirmed",
        sortable: false,
        width: "20%"
      },
      { text: "Actions", value: "action", sortable: false, width: "20%" }
    ];
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      //const [year, month, day] = date.split("-");
      let d = new Date(date);

      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    },
    formatDateTime(datetime) {
      //console.log(datetime,);
      return moment(datetime).format("DD/MM/YYYY, HH:MM");
    },

    openconfirmInternshipDialog(id) {
      this.internshipId = id;
      this.confirmInternshipDialog = true;
    },
    confirmationSave(status) {
      this.$http
        .put(
          "/trainer/" +
            this.user.id +
            "/action-on/internship/" +
            this.internshipId +
            "/" +
            status,
          {},
          {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        )
        .then(res => {
          //console.log(res);

          this.snackbarContent = "Your response has been saved";
          this.snackbarColor = "success";
          this.snackbar = true;

          this.confirmInternshipDialog = false;
        })
        .catch(e => {
          //console.log(e.response);
          this.snackbarContent = "There was an error saving your response.";
          this.snackbarColor = "red";
          this.snackbar = true;
        });
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  }
};
</script>
